import { v4 as uuid } from 'uuid';
import { add, compact, find, map, multiply, reduce } from 'lodash';
import { toUUID, round } from '../../util/transform';
import type { IHousehold } from './Household.interface';
import HouseholdExpense from './HouseholdExpense';
import { householdExpenseTypes } from './HouseholdExpense.enum';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export default class Household implements IHousehold {
  id: string;
  idContacts: Array<string>;
  householdExpenses: Array<HouseholdExpense>;

  static getTotalGroupOrAllExpensesByHousehold = (householdExpenses) => {
    return round(
      reduce(
        householdExpenses || [],
        (sum, n) =>
          add(
            sum,
            multiply(
              n?.value || 0,
              PaymentFrequency.getFrequencyValue(n?.frequency?.name || '', true)
            )
          ),
        0
      )
    );
  };

  static build = (data: IHousehold) => new Household(data);
  static blank = () => new Household();

  /**
   * Constructor
   * @param {IHousehold} data
   */
  constructor(data?: IHousehold) {
    this.id = toUUID(data?.id) || uuid();
    this.idContacts = compact(map(data?.idContacts, (obj) => toUUID(obj)));
    this.householdExpenses = map(
      map(householdExpenseTypes, (householdExpenseType) => {
        const householdExpense = find(
          data?.householdExpenses,
          (he) => he.type.name === householdExpenseType
        );
        return householdExpense || { type: { name: householdExpenseType } };
      }),
      (obj) => new HouseholdExpense(obj)
    );
  }
}
